import React, { useEffect } from 'react';

const News = () => {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
        }
      });
    }, observerOptions);

    const elements = document.querySelectorAll('.fade-on-scroll');
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const newsItems = [
    {
      date: "March 2025",
      title: "UK Stage Announces Flagship Luxury Residential Project",
      description: "200,000+ sq. ft. development with $40 million gross development value set to transform luxury living in the region."
    },
    {
      date: "February 2025",
      title: "Members-Only Sports Club Development Begins",
      description: "State-of-the-art 60,000 sq ft facility designed to serve over 10,000 members with professional-grade facilities for 10+ sports."
    },
    {
      date: "January 2025",
      title: "UK Stage Expands Strategic Land Banking Portfolio",
      description: "Group now controls over 200+ acres across multiple growth corridors, solidifying position as leading regional platform."
    }
  ];

  return (
    <div className="w-full">
      {/* Hero */}
      <section className="min-h-[60vh] flex items-center justify-center bg-[#F5F1ED] relative overflow-hidden">
        <div className="absolute left-20 top-1/4 w-96 h-96 border border-[#A08872]/10 rounded-full"></div>
        <div className="container mx-auto px-6 py-20 relative z-10">
          <p className="text-sm text-[#8B7355] uppercase tracking-widest mb-4 fade-on-scroll opacity-0">LATEST UPDATES</p>
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-serif text-[#2A2A2A] mb-6 fade-on-scroll opacity-0">News</h1>
        </div>
      </section>

      {/* News Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6 max-w-6xl">
          <div className="space-y-12">
            {newsItems.map((item, index) => (
              <div key={index} className="border-b border-[#EDE8E3] pb-12 last:border-b-0 fade-on-scroll opacity-0">
                <p className="text-sm text-[#8B7355] uppercase tracking-widest mb-4">{item.date}</p>
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif text-[#2A2A2A] mb-4">{item.title}</h2>
                <p className="text-lg text-[#3D3D3D] leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Image Section */}
      <section className="py-0">
        <img 
          src="https://images.unsplash.com/photo-1631377952034-a0460eba141f?w=1600&q=80" 
          alt="Himalayan Development"
          className="w-full h-[220px] sm:h-[400px] md:h-[600px] object-cover fade-on-scroll opacity-0"
        />
      </section>

      {/* More Coming Soon */}
      <section className="py-16 md:py-32 bg-[#EDE8E3] text-center">
        <div className="container mx-auto px-6 max-w-4xl fade-on-scroll opacity-0">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-serif text-[#2A2A2A] mb-6">
            More updates coming soon
          </h2>
          <p className="text-xl text-[#3D3D3D]">
            Stay tuned for the latest developments from UK Stage
          </p>
        </div>
      </section>
    </div>
  );
};

export default News;